import React from 'react';
import PropTypes from 'prop-types';

import { useLocalStorage } from 'utils/hooks/useLocalStorage';
import { CONDITIONS, KEYS } from '../utils/constants';
import { useOfferings } from '../utils/useOfferings';

import PregnancyPlan from '../PregnancyPlan';
import PostpartumPlan from '../PostpartumPlan';
import PainPlan from '../PainPlan';

const Plans = ({ userId, path }) => {
  const [selectedPath] = useLocalStorage(KEYS.PATH);

  const { offeringList, selectedOffer, setSelectedOffer, isDiscount, currentIdentifier, isFetchingOfferings } =
    useOfferings(userId);

  switch (path || selectedPath) {
    case CONDITIONS.PREGNANCY:
      return (
        <PregnancyPlan
          offerings={offeringList}
          selectedOffer={selectedOffer}
          setSelectedOffer={setSelectedOffer}
          isDiscount={isDiscount}
          identifier={currentIdentifier}
          isFetchingOfferings={isFetchingOfferings}
        />
      );
    case CONDITIONS.POSTPARTUM:
      return (
        <PostpartumPlan
          offerings={offeringList}
          selectedOffer={selectedOffer}
          setSelectedOffer={setSelectedOffer}
          isDiscount={isDiscount}
          identifier={currentIdentifier}
          isFetchingOfferings={isFetchingOfferings}
        />
      );
    case CONDITIONS.INCONTINENCE:
    case CONDITIONS.SEXUAL:
      return (
        <PainPlan
          offerings={offeringList}
          selectedOffer={selectedOffer}
          setSelectedOffer={setSelectedOffer}
          isDiscount={isDiscount}
          identifier={currentIdentifier}
          isFetchingOfferings={isFetchingOfferings}
        />
      );
    default:
      return null;
  }
};

Plans.defaultProps = {
  userId: null,
  path: null,
};

Plans.propTypes = {
  userId: PropTypes.string,
  path: PropTypes.string,
};

export default Plans;
